import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import users from 'modules/core/store/collections/users'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import WorkSchedulesContainer from 'modules/work_schedules/components/WorkSchedulesContainer'

const WorkSchedulesRootPage = () => {
  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  if (loading) {
    return <Loading />
  }

  return (
    <AuthorizeUser
      authorizeFn={() => users.current.policy.can('workSchedule.manageCompanySchedules')}
    >
      <WorkSchedulesContainer contractVersions={contractVersions} />
    </AuthorizeUser>
  )
}

export default WorkSchedulesRootPage
